export const logos = [
  {
    name: 'East Cheshire NHS Trust',
    src: '/assets/icons/east-cheshire.svg',
    width: 158,
    height: 48,
  },
  {
    name: 'East Kent Hospitals University NHS Foundation Trust',
    src: '/assets/icons/east-kent.png',
    width: 158,
    height: 48,
  },
  {
    name: 'Galenicals (University of Bristol Medical Student Society)',
    src: '/assets/icons/galenicals-logo.png',
    width: 158,
    height: 48,
  },
  {
    name: 'Mind the Bleep',
    src: '/assets/icons/mind-the-bleep.png',
    width: 158,
    height: 48,
  },
  {
    name: 'RCoA (Royal College of Anaesthetists)',
    src: '/assets/icons/rcoa.svg',
    width: 158,
    height: 48,
  },
  {
    name: 'RCEM (Royal College of Emergency Medicine)',
    src: '/assets/icons/rcem.png',
    width: 158,
    height: 48,
  },

  {
    name: 'Beyond the Foundation',
    src: '/assets/icons/beyond-the-foundation.png',
    width: 158,
    height: 48,
  },
  {
    name: 'Infomed Online',
    src: '/assets/icons/infomed-online.jpg',
    width: 158,
    height: 48,
  },
  {
    name: 'Medipath International',
    src: '/assets/icons/medipath-international.jpeg',
    width: 158,
    height: 48,
  },
  {
    name: 'OSCEazy',
    src: '/assets/icons/osceazy.jpeg',
    width: 158,
    height: 48,
  },
  {
    name: 'Maidstone and Tunbridge Wells NHS Trust',
    src: '/assets/icons/nhs-mtw.png',
    width: 158,
    height: 48,
  },
  {
    name: 'MediWord',
    src: '/assets/icons/mediword.png',
    width: 158,
    height: 48,
  },
  {
    name: 'Sheffield Teaching Hospitals NHS Foundation Trust',
    src: '/assets/icons/nhs-sth.png',
    width: 158,
    height: 48,
  },
  {
    name: 'QUESMED',
    src: '/assets/icons/quesmed.png',
    width: 158,
    height: 48,
  },
  {
    name: 'SUPTA',
    src: '/assets/icons/supta.jpeg',
    width: 158,
    height: 48,
  },
  {
    name: 'University of Cambridge',
    src: '/assets/icons/cambridge-university.svg',
    width: 158,
    height: 48,
  },
  {
    name: 'PPALS',
    src: '/assets/icons/ppals.jpeg',
    width: 158,
    height: 48,
  },
  {
    name: 'Optimise Interviews',
    src: '/assets/icons/optimise-interviews.jpeg',
    width: 158,
    height: 48,
  },
  {
    name: 'Kung Medics',
    src: '/assets/icons/kung-medics.jpeg',
    width: 158,
    height: 48,
  },
  {
    name: 'Endeavour Medical',
    src: '/assets/icons/endeavour-medical.png',
    width: 158,
    height: 48,
  },
  {
    name: 'Gradscape',
    src: '/assets/icons/gradscape.jpeg',
    width: 158,
    height: 48,
  },
  {
    name: 'Royal College of Surgeons (Edinburgh)',
    src: '/assets/icons/rcos-edinburgh.webp',
    width: 158,
    height: 48,
  },
  {
    name: 'Zero to Hero',
    src: '/assets/icons/zerotohero.jpeg',
    width: 158,
    height: 48,
  },
  {
    name: 'Intelligent Paces',
    src: '/assets/icons/intelligent-paces.jpeg',
    width: 158,
    height: 48,
  },
];
